import { render } from "./AddRedevancePage.vue?vue&type=template&id=52f394bc&ts=true"
import script from "./AddRedevancePage.vue?vue&type=script&lang=ts"
export * from "./AddRedevancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__